import { songs } from '@/data/songs.js'

export default {
  namespaced: true,
  state: () => ({
    currentId: null,
    playing: false,
    time: 0,
    duration: 0,
    volume: 0.7,
  }),
  getters: {
    current: s => songs.find(song => song.id === s.currentId) || null,
    list: () => songs,
  },
  mutations: {
    setCurrent(s, id) { s.currentId = id },
    setPlaying(s, v) { s.playing = v },
    setTime(s, t) { s.time = t },
    setDuration(s, d) { s.duration = d },
    setVolume(s, v) { s.volume = Math.max(0, Math.min(1, v)) },
  },
  actions: {
    play({ commit, state }, id) {
      if (id) commit('setCurrent', id)
      commit('setPlaying', true)
    },
    pause({ commit }) { commit('setPlaying', false) },
    toggle({ state, commit, dispatch }) {
      if (state.playing) {
        dispatch('pause')
      } else {
        dispatch('play', state.currentId)
      }
    },
  },
}
